<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
      style="padding: 0 10px"
    >
      <zj-layout-header>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="项目名称">
            <el-select v-model="ClientCode" placeholder="请选择">
              <el-option
                v-for="item in ClientCodeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="left">
            <el-button @click="onTreeSearch">查 询</el-button>
          </el-form-item>
        </el-form>
        <!-- <el-divider></el-divider> -->
      </zj-layout-header>
      <el-divider></el-divider>
      <div class="zj-layout-container user-layout" style="margin-bottom: 20px">
        <div class="zj-layout-left" style="height: 100%">
          <div class="zj-left-header">
            <el-button type="text" @click="treeAdd">新增</el-button>
            <el-button type="text" @click="treeEdit">编辑</el-button>
            <el-button type="text" @click="treeDel">删除</el-button>
          </div>
          <el-divider></el-divider>
          <div class="zj-left-main" style="height: 75%">
            <el-tree
              class="flow-tree"
              :data="nodes"
              :props="defaultProps"
              @node-click="handleNodeClick"
              highlight-current="true"
            >
            </el-tree>
          </div>
        </div>
        <div class="zj-layout-right" style="height: 100%">
          <!-- <zj-layout-header>
            <el-form
              class="zj-search-form"
              ref="form"
              :model="form"
              :label-width="labelWidth"
            >
              <el-form-item label="配置键名">
                <el-input
                  v-model="ItemKey"
                  placeholder="请输入配置键名"
                ></el-input>
              </el-form-item>
              <el-form-item label="登录名">
                <el-input
                  v-model="Login_Name"
                  placeholder="请输入登录名"
                ></el-input>
              </el-form-item>
              <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
              </el-form-item>
            </el-form>
            <el-divider></el-divider>
          </zj-layout-header> -->
          <zj-layout-main>
            <div class="zj-button-bar">
              <el-button @click="onAdd">标准格式添加</el-button>
              <el-button @click="onCustomAdd">自定义格式配置</el-button>
            </div>
            <div style="height: 100%">
              <div class="zj-table-container" style="height: 80%">
                <el-table
                  :data="tableData"
                  ref="multipleTable"
                  border
                  style="width: 100%; height: 100%"
                  height="100%"
                  fixed
                >
                  <el-table-column
                    prop="ItemKey"
                    label="配置键名"
                  ></el-table-column>
                  <el-table-column
                    prop="ItemValue"
                    label="配置键值"
                  ></el-table-column>
                  <el-table-column
                    prop="Description"
                    label="描述"
                  ></el-table-column>
                  <el-table-column
                    prop="Extend1"
                    label="扩展1"
                  ></el-table-column>
                  <el-table-column
                    prop="Extend2"
                    label="扩展2"
                  ></el-table-column>
                  <el-table-column fixed="right" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button
                        @click="editClick(scope.$index, scope.row)"
                        type="text"
                        size="small"
                        >编辑</el-button
                      >
                      <el-button
                        @click="deleteClick(scope.$index)"
                        type="text"
                        size="small"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </zj-layout-main>
        </div>
      </div>
    </zj-layout-container>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
    >
      <UniformSysConfigInfo
        @clickCancel="handleDialogCancel"
        :query="query"
        :SysConfigArr="SysConfigArr"
      ></UniformSysConfigInfo>
    </el-dialog>
    <el-dialog
      :title="itemDialogTitle"
      :visible.sync="itemDialogVisible"
      width="50%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
    >
      <UniformConfigInfo
        @clickCancel="handleItemDialogCancel"
        :query="query"
      ></UniformConfigInfo>
    </el-dialog>
    <el-dialog
      :title="itemDialogTitle"
      :visible.sync="customItemDialogVisible"
      width="50%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
    >
      <UniformConfigCustomInfo
        @clickCancel="handleCustomItemDialogCancel"
        :query="query"
      ></UniformConfigCustomInfo>
    </el-dialog>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import UniformSysConfigInfo from "./UniformSysConfigInfo.vue";
import UniformConfigInfo from "./UniformConfigInfo.vue";
import UniformConfigCustomInfo from "./UniformConfigCustomInfo.vue";
import utils from "../../../../../../utils";
export default {
  name: "UniformSysConfigView",
  controller: "UI",
  action: "UniformSysConfigView",
  components: {
    UniformSysConfigInfo,
    UniformConfigInfo,
    UniformConfigCustomInfo,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      EqName: "",
      EqType: "",
      SysConfigArr: [],
      ConfigItemsArr: [],
      nodes: [],
      defaultProps: {
        children: "children",
        label: "SysName",
      },
      dialogVisible: false,
      itemDialogVisible: false,
      customItemDialogVisible: false,
      itemDialogTitle: "",
      query: {},
      dialogTitle: "",
      SelectedSys: {},
      parentData: {},
      configItemData: {},
      ClientCode: "BasicSystem",
      loading: false,
      loadingText: "加载中...",
      //TODO 待扩展项目
      ClientCodeArr: [
        {
          value: "BasicSystem",
          label: "基准配置",
        },
        {
          value: ZJApp.ZJUser.current.Departments[0].OrgId,
          label: ZJApp.ZJUser.current.Departments[0].OrgName,
        },
      ],
    };
  },
  created: function () {
    this.init();
  },
  mounted: function () {
    // this.search();
    // this.logInfo.ActionName = "POI查询";
    // this.logInfo.LogMessage = "POI查询";
    // this.logInfo.ModuleName = "设备管理";
    // this.logInfo.PageName = "POI管理列表";
    // this.addOperationLog();
  },
  methods: {
    init() {
      this.loading = true;
      this.loadingText = "加载中...";
      this.SelectedSys = {};
      return utils
        .waitAll([() => this.getSysConfigs(), () => this.getConfigs()])
        .then((r) => {
          this.SysConfigArr = r[0].data.Data.PageContents;
          this.ConfigItemsArr = r[1].data.Data.PageContents;
          this.convertToTreeNodesfunction(this.SysConfigArr);
          //this.convertToTreeNodes1(this.SysConfigArr);
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getSysConfigs() {
      const searchObj = {
        ClientCode: this.ClientCode,
        ClientVersion: "Alpha",
        PageSize: 100000,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      return new MyApis.UniformSysConfigApi().GetConfigSysMangePagingList(
        searchObj
      );
    },
    getConfigs() {
      const searchObj = {
        ClientCode: this.ClientCode,
        ClientVersion: "Alpha",
        PageSize: 100000,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      return new MyApis.UniformConfigApi().GetConfigPagingList(searchObj);
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      let res = [];
      let mapA = {};
      // const that = this;
      // 第一次循环得到id对应的map对象
      list.forEach((element) => {
        mapA[element.SysId] = element;
      });
      // 第二次循环数组ConfigItemsArr，对比map对象和B数组的每一项
      //过滤掉在sys表中已存在的记录
      this.ConfigItemsArr.forEach((item) => {
        if (!mapA[item.ConfigId]) {
          res.push(item);
        }
      });
      for (let i = 0; i < list.length; i++) {
        var sysConfigData = list[i];

        var sysConfig = {
          SysId: sysConfigData.SysId,
          SysCode: sysConfigData.SysCode,
          Extend1: sysConfigData.Extend1,
          SysName: sysConfigData.SysName,
          Description: sysConfigData.Description,
          ClientCode: sysConfigData.ClientCode,
          CreateTime: sysConfigData.CreateTime,
          Creater: sysConfigData.Creater,
          children: [],
        };

        for (let j = 0; j < res.length; j++) {
          var ConfigItemsData = res[j];
          if (
            ConfigItemsData.SysCode == sysConfigData.SysCode &&
            ConfigItemsData.ClientCode == sysConfigData.ClientCode &&
            ConfigItemsData.ClientVersion == sysConfigData.ClientVersion
          ) {
            if (ConfigItemsData.UKeyName != null) {
              sysConfig.children.push({
                SysId: ConfigItemsData.ConfigId,
                SysCode: ConfigItemsData.SysCode,
                Extend1: ConfigItemsData.SysCode,
                SysName:
                  ConfigItemsData.UKey + "(" + ConfigItemsData.UKeyName + ")",
                Description: ConfigItemsData.Description,
                UKeyName: ConfigItemsData.UKeyName,
                UKey: ConfigItemsData.UKey,
                ClientCode: ConfigItemsData.ClientCode,
                CreateTime: ConfigItemsData.CreateTime,
                Creater: ConfigItemsData.Creater,
                children: [],
              });
            } else {
              sysConfig.children.push({
                SysId: ConfigItemsData.ConfigId,
                SysCode: ConfigItemsData.SysCode,
                Extend1: ConfigItemsData.SysCode,
                SysName: ConfigItemsData.UKey,
                Description: ConfigItemsData.Description,
                ClientCode: ConfigItemsData.ClientCode,
                UKeyName: ConfigItemsData.UKeyName,
                UKey: ConfigItemsData.UKey,
                CreateTime: ConfigItemsData.CreateTime,
                Creater: ConfigItemsData.Creater,
                children: [],
              });
            }
          }
        }

        result.push(sysConfig);
      }
      // this.nodes = result;
      this.convertToTreeNodes(result);
    },
    convertToTreeNodes(dataList) {
      let formatObj = dataList.reduce((pre, cur) => {
        return { ...pre, [cur["SysId"]]: cur };
      }, {});

      let formatArray = dataList.reduce((arr, cur) => {
        let pid = cur.Extend1 ? cur.Extend1 : 0;
        let parent = formatObj[pid];
        if (parent) {
          parent.children
            ? parent.children.push(cur)
            : (parent.children = [cur]);
        } else {
          arr.push(cur);
        }
        return arr;
      }, []);
      this.nodes = formatArray;
      // this.convertToTreeNodesfunction(formatArray);
    },
    handleNodeClick(data, node) {
      this.SelectedSys = data;
      this.getParent(node);
      this.getConfigItemInfo();
    },
    getParent(node) {
      if (node.parent && !Array.isArray(node.parent.data)) {
        this.parentData = node.parent.data;
        this.getParent(node.parent);
      }
    },
    onTreeSearch() {
      this.init();
    },
    //添加配置
    treeAdd() {
      let canAdd = true;
      if (this.SelectedSys !== null && this.SelectedSys.SysId != undefined) {
        canAdd = this.SysConfigArr.some((item) => {
          return item.SysId == this.SelectedSys.SysId;
        });
      }
      if (canAdd) {
        this.dialogTitle = "新增子系统";
        this.dialogVisible = true;
        this.query = {
          type: "add",
          SelectedSys: this.SelectedSys,
        };
      } else {
        this.$message({
          message: "该数据为子系统已维护数据，不能添加子目录!",
          type: "warning",
        });
      }
    },
    treeEdit() {
      let canEdit = true;
      if (this.SelectedSys !== null && this.SelectedSys.SysId != undefined) {
        canEdit = this.SysConfigArr.some((item) => {
          return item.SysId == this.SelectedSys.SysId;
        });
        if (canEdit) {
          this.dialogTitle = "修改子系统";
          this.dialogVisible = true;
          this.query = {
            SelectedSys: this.SelectedSys,
            type: "edit",
          };
        } else {
          this.$message({
            message: "该数据为子系统已维护数据，不能修改目录!",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "请选择子系统配置!",
          type: "warning",
        });
      }
    },
    handleDialogCancel(r) {
      this.dialogVisible = false;
      if (r) {
        this.init();
      }
    },
    handleItemDialogCancel(r) {
      this.itemDialogVisible = false;
      if (r) {
        this.getConfigItemInfo();
      }
    },
    handleCustomItemDialogCancel(r) {
      this.customItemDialogVisible = false;
      if (r) {
        this.getConfigItemInfo();
      }
    },
    //获取配置明细
    getConfigItemInfo() {
      this.tableData = [];
      let searchInfo = {
        ConfigId: this.SelectedSys.SysId,
      };
      const that = this;
      new MyApis.UniformConfigApi()
        .GetDataById(searchInfo)
        .then((r) => {
          r = r.data.Data;
          if (r) {
            that.configItemData = r;
            const UValue = JSON.parse(r.UValue);
            if (Array.isArray(UValue)) that.tableData = UValue;
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.itemDialogTitle = "新增配置项子项";
      this.itemDialogVisible = true;
      this.query = {
        type: "add",
        SelectedSys: this.SelectedSys,
        SysCode: this.parentData.SysCode,
        rowType: "",
      };
    },
    editClick(index, row) {
      this.itemDialogTitle = "修改配置项子项";
      this.itemDialogVisible = true;
      this.query = {
        rowType: "editRow",
        SelectedSys: this.SelectedSys,
        SysCode: this.parentData.SysCode,
        UValue: row,
        index: index,
      };
    },
    //自定义配置项子项添加
    onCustomAdd() {
      this.itemDialogTitle = "新增配置项子项";
      this.customItemDialogVisible = true;
      this.query = {
        type: "add",
        SelectedSys: this.SelectedSys,
        SysCode: this.parentData.SysCode,
      };
    },
    //行删除
    deleteClick(index) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tableData.splice(index, 1);
          this.configItemData.UValue = JSON.stringify(this.tableData);
          this.configItemData.ModifyTime = new Date();
          this.configItemData.Modifier = ZJApp.ZJUser.current.UserName;
          new MyApis.UniformConfigApi()
            .UpdateConfig(this.configItemData)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.logInfo.ActionName = "删除配置项子项";
              this.logInfo.LogMessage = r
                ? "配置项子项删除成功"
                : "配置项子项删除失败";
              this.logInfo.ModuleName = "配置管理";
              this.logInfo.PageName = "子系统配置";
              this.addOperationLog();
              this.getConfigItemInfo();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    treeDel() {
      if (!this.SelectedSys || this.SelectedSys.SysId == undefined) {
        this.$message({
          message: "请选择要删除的项!",
          type: "info",
        });
        return;
      }

      if (
        this.SelectedSys.children != null &&
        this.SelectedSys.children.length > 0
      ) {
        this.$message({
          message: "有子目录无法删除!",
          type: "error",
        });
        return;
      }

      this.$confirm("确定删除该目录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        let SysId = this.SelectedSys.SysId;
        return utils
          .waitAll([
            () => this.delConfigSysData(SysId),
            () => this.delConfigData(),
          ])
          .then((r) => {
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.loading = false;
            this.logInfo.ActionName = "删除配置项目录";
            this.logInfo.LogMessage = r
              ? "配置项目录删除成功"
              : "配置项目录删除失败";
            this.logInfo.ModuleName = "配置管理";
            this.logInfo.PageName = "子系统配置";
            this.addOperationLog();
            this.init();
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      });
    },
    delConfigData() {
      if (this.configItemData != null) {
        return new MyApis.UniformConfigApi().DelConfig({
          ConfigId: this.configItemData.ConfigId,
        });
      }
    },
    delConfigSysData(SysId) {
      return new MyApis.UniformSysConfigApi().DelConfigSys({ SysId: SysId });
    },
  },
};
</script>
<style scoped>

.flow-tree {
  overflow: auto;
  height: 100%;
}

/deep/.flow-tree > .el-tree-node > .el-tree-node__children {
  overflow: visible !important;
}
</style>